import { PhitoRoute, PhitoRoutes } from '../../app/app/phito-routes'
import { PermissionAction } from '../administration/role-and-permissions/role-and-permission'

export const TICKET_ROUTES = {
    overview: new PhitoRoute(
        'Tickets',
        'label',
        PermissionAction.Ansehen('Ticket', 'Ticket'),
        'tickets',
        () => ['tickets'],
        import('./ticket-overview/ticket-overview.component').then((m) => m.TicketOverviewComponent),
    ) satisfies PhitoRoute<[]>,
    details: new PhitoRoute(
        'Ticket-Details',
        'label',
        PermissionAction.Ansehen('Ticket', 'Ticket'),
        'tickets/:id',
        (id: string) => ['tickets', id],
        import('./ticket-details/ticket-details.component').then((m) => m.TicketDetailsComponent),
    ) satisfies PhitoRoute<[string]>,
} satisfies PhitoRoutes;
